// extracted by mini-css-extract-plugin
module.exports = {"editor":"CompanyNoteEditor_editor__1zqlT","postBtn":"CompanyNoteEditor_postBtn__1I5aC"};